import React from "react";
import IPostGridVerifySingleAddress from "../../../../models/PostGrid/IPostGridVerifySingleAddress";

type Props = {
    data?: IPostGridVerifySingleAddress;
    errorProp: string;
};

export const AddressVerificationErrorDisplay = (props: Props) => {
    let errorArr: string[] = [];

    if (props.data?.data?.errors) {
        // @ts-expect-error
        errorArr = props.data.data.errors[props.errorProp] || [];
    }

    return (
        <div className={"AddressVerificationErrorDisplay"}>
            {errorArr.map((errorMsg: string, index: number) => {
                return (
                    <div key={index} className={"text-danger"}>
                        {errorMsg}
                    </div>
                );
            })}
        </div>
    );
};
